import CompetitionSelect from './CompetitionSelect';

export default CompetitionSelect;
